import React from 'react';
import { DateInput, TextInput } from 'ui-toolkit';
import partsFromDate, { generateDateText } from '../utilities/partsFromDate';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IHasMetaDataModalProps from './IHasMetaDataModalProps';
import IHasMetaDataModalState from './IHasMetaDataModalState';
import IItemProps from './IItemProps';
import ItemMetaDataModal, { IItemMetaDataModalRef } from './ItemMetaDataModal/ItemMetaDataModal';
import SharedItemCells from './SharedItemCells';
import './_PropertyTaxes.scss';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import { transformDateInputToValue } from '../utilities/transformDateInputToValue';
import { IPropertyTaxesViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface IPropertyTaxesProps
  extends IItemProps,
    IHasItemDataProps<IPropertyTaxesViewItem>,
    Required<IHasItemEventProps<IPropertyTaxesViewItem>>,
    IHasMetaDataModalProps {}

type IPropertyTaxesState = IHasMetaDataModalState;

export default class PropertyTaxes extends React.Component<IPropertyTaxesProps, IPropertyTaxesState> {
  public state = { expanded: !this.props.disableAutoExpand && this.props.data.new };
  private modal = React.createRef<IItemMetaDataModalRef>();
  private firstInput: HTMLInputElement | null = null;

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;
    const { period, parcel_no, payee, date_to } = data;
    const toDate = partsFromDate(date_to);

    const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
    const periodOnChange = generateDefaultOnChangeHandler('period');
    const payeeOnChange = generateDefaultOnChangeHandler('payee');
    const parcelNoOnChange = generateDefaultOnChangeHandler('parcel_no');
    const toOnChange = generateDefaultOnChangeHandler('date_to', transformDateInputToValue);

    return (
      <div className="property-taxes">
        <SharedItemCells {...this.props} readOnly={!hasEditPermissions}>
          <ItemMetaDataModal
            expanded={this.state.expanded}
            ref={this.modal}
            label={
              <span>
                {period ? `${period} ` : ''}
                Property Taxes
                {payee ? ` to ${payee}` : ''}
                {parcel_no ? ` (${parcel_no})` : ''}
                {toDate ? ` Pd Through ${generateDateText(toDate)}` : ''}
              </span>
            }
            onToggle={this.onModalToggleEvent}
          >
            <div className="property-taxes__modal">
              <TextInput
                label={'Billing Period'}
                onChange={periodOnChange}
                placeholder="Billing Period"
                getInputRef={this.setFirstInput}
                value={period}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
              <TextInput
                label={'To'}
                onChange={payeeOnChange}
                placeholder="Payee"
                value={payee}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
              <TextInput
                label={'Parcel No.'}
                onChange={parcelNoOnChange}
                placeholder="Parcel No"
                value={parcel_no}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />

              <DateInput
                label={'Paid Through'}
                value={toDate ? `${toDate.year}-${toDate.month}-${toDate.date}` : null}
                name="date_to"
                onBlur={this.onBlurEvent}
                onChange={toOnChange}
                readOnly={!hasEditPermissions}
              />
            </div>
          </ItemMetaDataModal>
        </SharedItemCells>
      </div>
    );
  }

  private setFirstInput = (element: HTMLInputElement) => {
    this.firstInput = element;
  };

  private onBlurEvent = (event: React.FocusEvent) => {
    const node = this.modal.current;
    if (node && event.relatedTarget && !node.modalContains(event.relatedTarget as HTMLElement)) {
      this.setState({
        expanded: false,
      });
    }
  };

  private onModalToggleEvent = (expanded: boolean) => {
    this.setState({ expanded });
    if (this.firstInput) {
      this.firstInput.focus();
    }
  };
}
